export class EmployeeTypeModel {
    static Doctor = 1;
    static Doctor_Assistant = 2;
    static Hunchun_Coach = 3;
    static Physical_Therapist = 4;
    static Pharmacist = 5;
    static Administration_Manager = 6;
    static Administration_Assistant = 7;

    value: number;
    displayName: string;
    constructor(value, displayName) {
        this.value = value;
        this.displayName = displayName;
    }
}